import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ScrollableList, ScrollableListVariant, ScrollDirection } from '@as/cotopaxi';
import { Box, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetQuickLinks } from '../../../redux/lister/selectors/ListerSelector';
import { QuickFilterItem } from './QuickFilterItem';
export const QuickFilters = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const quickLinks = useSelector(makeGetQuickLinks());
    if (!(quickLinks && quickLinks.length > 0)) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { as: "span", strong: true, children: t('product.lister.quickFilters.title') }), _jsx(Box, { paddingBlockStart: "4", children: _jsx(ScrollableList, { direction: ScrollDirection.HORIZONTAL, variant: ScrollableListVariant.GRADIENT, touchOnly: true, dataAnalyticsBannerid: "product-lister-quicklinks", children: quickLinks.map(quickLink => (_jsx(QuickFilterItem, { quickLink: quickLink }, `quickLink_${quickLink.linkName}`))) }) })] }));
};
